<template>
    <div class="sign-up">
        <h3>{{ $t("messages.createAccount") }}</h3>
        <b-row>
            <b-col>
            <form @submit.prevent="submit">

            <div class="form-group" :class="{ 'form-group--error': $v.form.email.$error }">
                <label class="form__label">{{ $t("messages.email") }}</label>
                <input class="form-control" v-model.trim="$v.form.email.$model" />
            </div>
            <div v-if="$v.form.$error">
                <div class="error" v-if="!$v.form.email.required">{{ $t('messages.error.required') }}</div>
                <div class="error" v-if="!$v.form.email.email">{{ $t('messages.error.mailNotValid') }}</div>
                <div class="error" v-if="!$v.form.email.maxLength">{{ $t('messages.error.maxValue', { field: $t("messages.email"), value: $v.form.email.$params.maxLength.max }) }}</div>
            </div>

            <div class="form-group" :class="{ 'form-group--error': $v.form.password.$error }">
                <label class="form__label">{{ $t("messages.password") }}</label>
                <input class="form-control" type="password" v-model.trim="$v.form.password.$model"/>
            </div>
            <div v-if="$v.form.$error">
                <div class="error" v-if="!$v.form.password.required">{{ $t('messages.error.required') }}</div>
                <div class="error" v-if="!$v.form.password.minLength">{{ $t('messages.error.minLength', { field: $t("messages.password"), value: $v.form.password.$params.minLength.min }) }} </div>
                <div class="error" v-if="!$v.form.password.maxLength">{{ $t('messages.error.maxLength', { field: $t("messages.password"), value: $v.form.password.$params.maxLength.max }) }} </div>
            </div>
        
            <div class="form-group" :class="{ 'form-group--error': $v.form.repeatPassword.$error }">
                <label class="form__label">{{ $t("messages.repeatPassword") }}</label>
                <input class="form-control" type="password" v-model.lazy="$v.form.repeatPassword.$model" data-vv-validate-on="blur" />
            </div>
            <div v-if="$v.form.$error">
                <div class="error" v-if="!$v.form.repeatPassword.sameAsPassword"> {{ $t('messages.error.passwordIdentical') }}</div>
            </div>

            <div class="form-group" :class="{ 'form-group--error': $v.form.terms.$error }" >
                <label class="form__label">{{ $t("messages.legal") }}</label>
                    <b-form-checkbox class="form-control"
                    id="checkbox-1"
                    v-model="$v.form.terms.$model"
                    name="checkbox-1"
                    value=true
                    unchecked-value="false"
                    >
                        {{ $t("messages.acceptPolicy") }}   <a href="https://bodytone.eu/es/aviso-de-privacidad/" target="_blank" style="color:#ffffff;margin-left:10px">+ Info </a>
                    </b-form-checkbox>
            </div>
            <div v-if="$v.form.$error">
                <div class="error" v-if="!$v.form.terms.sameAs"> {{ $t('messages.error.terms') }}</div>
            </div> 

            <div style="height:85px;overflow: hidden;">
                <vue-recaptcha 
                    sitekey="6LcDM5EUAAAAAM7swK0RCynoIpY8OtIA2s3v0OnX"
                    v-model="form.recaptcha"
                    @verify="onCapchaVerify"
                    style="margin-top:5px"
                    >
                </vue-recaptcha>
            </div>

            <div v-if="$v.form.$error && !form.recaptcha || form.recaptchaError">
                <div class="error"> {{ $t('messages.error.required') }}</div>
            </div>

            <button class="button" @click="reset()">{{ $t('messages.cancel') }}</button>
            
            <button type="submit">
                {{ $t("messages.request") }}
            </button>
        </form>
            <b-button class="remember" size="sm" variant="link" v-on:click="callLogin"> {{ $t("messages.backToLogin") }} </b-button>
        </b-col>    
    </b-row>
    </div>

</template>

<script>
const fb = require('../firebaseConfig.js')
import {required,email, numeric, sameAs,  minLength, maxLength, minValue, maxValue} from 'vuelidate/lib/validators';
import VueRecaptcha from 'vue-recaptcha';
import {TheMask} from 'vue-the-mask'
import Icon from 'vue-awesome/components/Icon'

export default {
    name: 'signUp',
    components: { 
        VueRecaptcha, 
        TheMask,
        'v-icon': Icon
        },
    props: { 
        actionCodeSettings: {

        }
    },
    data: function () {
        return {
            form: {
                email:"",
                password: "",
                repeatPassword:"",
                recaptcha:"",
                terms:"",
                recaptchaError: false
            }
        }
    },
    validations: {
        form: {
            email: {
                required,
                email,
                maxLength: maxLength(90)
            },
            password: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(10)
            },
           terms: {
                sameAs: sameAs( () => 'true' ),
            },
            repeatPassword: {
                sameAsPassword: sameAs('password')
            }
        }
    },
    computed: {
        currentLanguage: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].name;
        },
    },
    methods: {
        callLogin: function () {
            this.$emit('setLogin');
        },
        reset: function(){
            this.form.email = null;
            this.form.name = null;
            this.form.surname = null;
            this.form.pin = null;
            this.form.repeatPassword = null;
            this.$nextTick(() => { this.$v.$reset() })
        },
        onCapchaVerify: function (response) {
            this.form.recaptcha = true;
            this.form.recaptchaError= false;
            this.$v.form.$touch();
        },
        submit() {
            this.$v.form.$touch();
            if (this.$v.form.$error | !this.form.recaptcha){
                this.form.recaptchaError = true;
                return
            }
           this.signUp();
        },
        signUp: function () {
            fb.auth.createUserWithEmailAndPassword(this.form.email, this.form.password).then(
                (newUser) => {
                    //let lang = (this.form.lang) ? this.form.lang : 'es';
                    fb.usersCollection.doc(newUser.user.uid).set({
                        email: this.form.email,
                        isAdmin: false,
                        createdAt: Math.floor( Date.now() / 1000),
                        profileComplete: false,
                        cycling: { distance:0,energy:0,time:0,sessions:0,avgrpm:0,avgspeed:0,hrmax:0,maxpower:0 },
                        treadmill : { distance:0,energy:0,time:0,sessions:0,avgrpm:0,avgspeed:0,hrmax:0,maxpower:0 }
                       // language: lang
                    }).then(() => {
                        this.sendEmail();
                    }).catch(err => {
                         this.$emit('onError', err.message);
                    })
                },
                (err) => {
                    this.$emit('onError', err.message);
                }
            );
        },
        sendEmail: function () {
            if(this.form.lang){
                fb.auth.languageCode = this.form.lang
            }
            fb.auth.currentUser.sendEmailVerification(this.actionCodeSettings).then( (status) => {
                this.$emit('onSuccess', 'El proceso se ha realizado correctamente. Por favor, verifica tu correo para completar el registro.');
                this.$store.dispatch('clearData')
                this.$emit('setLogin');
          
            }).catch( (err) =>  {
                this.$emit('onError', err.message);
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SignUp.vue